var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisionStatementPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2633 0 0 1.35546 -64.904 -154.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M316.69 118.27H340.55V483.91999999999996H316.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.69 118.27H340.55V483.91999999999996H316.69z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M340.56 118.27H420V483.91999999999996H340.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 126.04H387.36V137.23000000000002H346.12z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.12 126.04H387.36V137.23000000000002H346.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 126.04H414.69V137.23000000000002H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M394.07 126.04H414.69V137.23000000000002H394.07z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 127.8L385.38 127.83 385.47 137.23 387.35 137.23 387.35 126.04 346.12 126.04z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 126.04L394.07 127.66 412.41 127.66 412.41 137.23 414.69 137.23 414.69 126.04z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 145.29H387.36V156.48H346.12z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.12 145.29H387.36V156.48H346.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 145.29H414.69V156.48H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M394.07 145.29H414.69V156.48H394.07z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 147.05L385.38 147.08 385.47 156.48 387.35 156.48 387.35 145.29 346.12 145.29z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 145.29L394.07 146.92 412.41 146.92 412.41 156.48 414.69 156.48 414.69 145.29z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 164.54H387.36V175.73H346.12z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.12 164.54H387.36V175.73H346.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 164.54H414.69V175.73H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M402.76 175.73L394.07 175.73 394.07 164.54 414.69 164.54 414.69 175.73 409.5 175.73 409.46 173.23 402.76 173.24z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 166.3L385.38 166.33 385.47 175.73 387.35 175.73 387.35 164.54 346.12 164.54z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 164.54L394.07 166.17 412.41 166.17 412.41 175.73 414.69 175.73 414.69 164.54z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 183.8H387.36V194.99H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 183.8H414.69V194.99H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M398.19 194.98L398.19 189.39 402.35 189.39 402.35 183.79 394.07 183.79 394.07 194.98z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M411.09 183.8H414.67999999999995V194.99H411.09z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M346.12 183.8H387.36V194.99H346.12z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 185.56L385.38 185.59 385.47 194.98 387.35 194.98 387.35 183.79 346.12 183.79z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 183.79L394.07 185.42 412.41 185.42 412.41 194.98 414.69 194.98 414.69 183.79z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 203.05H387.36V214.24H346.12z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M373.84 214.24L387.35 214.24 387.35 203.05 346.12 203.05 346.12 211.18 355.78 211.18 355.78 207.01 373.84 207.01z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 203.05H414.69V214.24H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M411.09 203.05H414.67999999999995V214.24H411.09z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 204.81L385.38 204.84 385.47 214.24 387.35 214.24 387.35 203.05 346.12 203.05z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M394.07 203.05H398.19V214.24H394.07z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 203.05L394.07 204.67 412.41 204.67 412.41 214.24 414.69 214.24 414.69 203.05z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 222.3H387.36V233.49H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 222.3H414.69V233.49H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 224.06L385.38 224.09 385.47 233.49 387.35 233.49 387.35 222.3 346.12 222.3z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 222.3L394.07 223.93 412.41 223.93 412.41 233.49 414.69 233.49 414.69 222.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 241.55H387.36V252.74H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 241.55H414.69V252.74H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 243.31L385.38 243.34 385.47 252.74 387.35 252.74 387.35 241.55 346.12 241.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 241.55L394.07 243.18 412.41 243.18 412.41 252.74 414.69 252.74 414.69 241.55z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 260.81H387.36V272H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 260.81H414.69V272H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 262.57L385.38 262.6 385.47 271.99 387.35 271.99 387.35 260.81 346.12 260.81z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 260.81L394.07 262.43 412.41 262.43 412.41 271.99 414.69 271.99 414.69 260.81z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 280.06H387.36V291.25H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 280.06H414.69V291.25H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 281.82L385.38 281.85 385.47 291.25 387.35 291.25 387.35 280.06 346.12 280.06z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 280.06L394.07 281.68 412.41 281.68 412.41 291.25 414.69 291.25 414.69 280.06z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 299.31H387.36V310.5H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 299.31H414.69V310.5H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 301.07L385.38 301.1 385.47 310.5 387.35 310.5 387.35 299.31 346.12 299.31z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 299.31L394.07 300.94 412.41 300.94 412.41 310.5 414.69 310.5 414.69 299.31z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 318.56H387.36V329.75H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 318.56H414.69V329.75H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 320.32L385.38 320.36 385.47 329.75 387.35 329.75 387.35 318.56 346.12 318.56z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 318.56L394.07 320.19 412.41 320.19 412.41 329.75 414.69 329.75 414.69 318.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 337.82H387.36V349.01H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 337.82H414.69V349.01H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 339.58L385.38 339.61 385.47 349 387.35 349 387.35 337.82 346.12 337.82z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 337.82L394.07 339.44 412.41 339.44 412.41 349 414.69 349 414.69 337.82z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M346.12 357.07H387.36V368.26H346.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M394.07 357.07H414.69V368.26H394.07z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.12 358.83L385.38 358.86 385.47 368.26 387.35 368.26 387.35 357.07 346.12 357.07z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.07 357.07L394.07 358.69 412.41 358.69 412.41 368.26 414.69 368.26 414.69 357.07z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 128.09H334.46999999999997V136.14000000000001H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 146.84H334.46999999999997V154.89000000000001H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 165.81H334.46999999999997V173.86H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 184.78H334.46999999999997V192.83H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 203.75H334.46999999999997V211.8H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 222.71H334.46999999999997V230.76000000000002H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 241.68H334.46999999999997V249.73000000000002H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 260.65H334.46999999999997V268.7H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 279.62H334.46999999999997V287.67H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 298.59H334.46999999999997V306.64H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 317.55H334.46999999999997V325.6H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M329.44 336.52H334.46999999999997V344.57H329.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 128.09H326.30999999999995V136.14000000000001H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 146.84H326.30999999999995V154.89000000000001H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 165.81H326.30999999999995V173.86H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 184.78H326.30999999999995V192.83H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 203.75H326.30999999999995V211.8H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 222.71H326.30999999999995V230.76000000000002H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 241.68H326.30999999999995V249.73000000000002H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 260.65H326.30999999999995V268.7H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 279.62H326.30999999999995V287.67H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 298.59H326.30999999999995V306.64H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 317.55H326.30999999999995V325.6H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M321.28 336.52H326.30999999999995V344.57H321.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 272c0 .15-9 .26-20.17.26-11.17 0-20.18-.11-20.18-.26 0-.15 9-.26 20.18-.26s20.17.11 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 272a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 291.45c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 291.45a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 310.91c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.11 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 310.91a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 79.38 79.38 0 019.17-.26 79.38 79.38 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 330.36c0 .15-9 .26-20.17.26-11.17 0-20.18-.11-20.18-.26 0-.15 9-.26 20.18-.26s20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 330.36a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 349.82c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.11 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 349.82a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 79.38 79.38 0 019.17-.26 79.38 79.38 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 369.27c0 .15-9 .26-20.17.26-11.17 0-20.18-.11-20.18-.26 0-.15 9-.26 20.18-.26s20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 369.27a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 195.2c0 .15-9 .26-20.17.26-11.17 0-20.18-.11-20.18-.26 0-.15 9-.26 20.18-.26s20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 175.73c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 156.26c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 214.24c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.11 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 233.27c0 .14-9 .26-20.17.26-11.17 0-20.18-.12-20.18-.26s9-.26 20.18-.26 20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386.47 252.3c0 .15-9 .26-20.17.26-11.17 0-20.18-.11-20.18-.26 0-.15 9-.26 20.18-.26s20.17.12 20.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M385.69 137.18c0 .14-9 .26-20.09.26s-20.08-.12-20.08-.26 9-.26 20.08-.26c11.08 0 20.09.08 20.09.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 137.18a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 79.38 79.38 0 019.17-.26 79.38 79.38 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 156.26a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 175.34a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 195.2a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 214.24a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 79.38 79.38 0 019.17-.26 79.38 79.38 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 233.34a82.17 82.17 0 01-9.17.26 82.17 82.17 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413 252.44a79.38 79.38 0 01-9.17.26 79.38 79.38 0 01-9.17-.26 82.17 82.17 0 019.17-.26 82.17 82.17 0 019.17.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M187.26 219.41H295.1V482.88H187.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M230.36 230.23H238.8V472.4H230.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M242.25 230.23H250.69V472.4H242.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M254.13 230.23H262.57V472.4H254.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M194.62 230.23H203.06V472.4H194.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M206.5 230.23H214.94V472.4H206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M266.01 230.23H274.45V472.4H266.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M277.89 230.23H286.33V472.4H277.89z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.26 219.41H221.83999999999997V482.88H187.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M261.66 257a13.79 13.79 0 01-2.45 2.81 13.42 13.42 0 01-2.81 2.45 25.88 25.88 0 015.26-5.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M272.17 264.13c.1.11-.65 1-1.68 2-1.03 1-1.94 1.7-2 1.59a7 7 0 011.68-2c.99-.98 1.9-1.72 2-1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M282.84 249.13c.1.1-.61 1-1.59 1.89-.98.89-1.86 1.61-2 1.51-.14-.1.61-.95 1.6-1.89.99-.94 1.89-1.64 1.99-1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M441.35 183.79H495.77000000000004V198.2H441.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M443.64 185.6H493.48V194.93H443.64z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M443.64 185.6H493.48V194.93H443.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M433.04 196.09H502.95000000000005V373.17H433.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M436.79 200.18H498.77000000000004V373.15999999999997H436.79z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M436.79 281.31L449.34 281.31 449.34 261.8 459.45 261.8 459.45 246.04 479.67 246.04 479.67 295.75 489.78 295.75 489.78 225.26 498.77 225.26 498.77 200.18 436.79 200.18z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 218.38c0 .15-14.86.26-33.18.26s-33.18-.11-33.18-.26c0-.15 14.85-.26 33.18-.26s33.18.12 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 236.13c0 .14-14.86.26-33.18.26s-33.18-.12-33.18-.26 14.85-.26 33.18-.26 33.18.13 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 253.88c0 .14-14.86.26-33.18.26s-33.18-.12-33.18-.26 14.85-.27 33.18-.27 33.18.12 33.18.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 271.62c0 .15-14.86.26-33.18.26s-33.18-.11-33.18-.26c0-.15 14.85-.26 33.18-.26s33.18.12 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 289.37c0 .14-14.86.26-33.18.26s-33.18-.12-33.18-.26 14.85-.26 33.18-.26 33.18.11 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 307.11c0 .15-14.86.26-33.18.26s-33.18-.11-33.18-.26c0-.15 14.85-.26 33.18-.26s33.18.15 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 324.86c0 .14-14.86.26-33.18.26s-33.18-.12-33.18-.26 14.85-.26 33.18-.26 33.18.12 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 342.61c0 .14-14.86.26-33.18.26s-33.18-.12-33.18-.26 14.85-.26 33.18-.26 33.18.11 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M501.62 360.35c0 .15-14.86.26-33.18.26s-33.18-.11-33.18-.26c0-.15 14.85-.26 33.18-.26s33.18.12 33.18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M450.9 376.86c-.15 0-.26-43-.26-96s.11-96 .26-96c.15 0 .26 43 .26 96s-.16 96-.26 96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M468.88 376.86c-.14 0-.26-43-.26-96s.12-96 .26-96 .27 43 .27 96-.15 96-.27 96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M486.87 376.86c-.14 0-.26-43-.26-96s.12-96 .26-96 .26 43 .26 96-.13 96-.26 96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M433.48 183.79H441.35V196.09H433.48z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.48 183.79H441.35V196.09H433.48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M425.51 196.2H433.38V345.23H425.51z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.51 196.2H433.38V345.23H425.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M466.29 221.61a54 54 0 01-5.14 5.19 50.31 50.31 0 01-5.5 4.82 54.67 54.67 0 015.14-5.2 50.82 50.82 0 015.5-4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M482.94 221.29a52.05 52.05 0 01-5.14 5.2 51.66 51.66 0 01-5.5 4.82 102.15 102.15 0 0110.64-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M483.22 207.2a50.67 50.67 0 01-5.14 5.2 52.44 52.44 0 01-5.49 4.82 49.52 49.52 0 015.14-5.2 51 51 0 015.49-4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M617.92 438.7L525.23 438.7 525.23 273.66 617.92 228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 345.13H570.72V357.11H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 345.13L562.38 346.61 569.32 346.61 569.32 357.11 570.72 357.11 570.72 345.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 368.31H570.72V380.29H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 368.31L562.38 369.8 569.32 369.8 569.32 380.29 570.72 380.29 570.72 368.31z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 391.5H570.72V403.48H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 391.5L562.38 392.98 569.32 392.98 569.32 403.48 570.72 403.48 570.72 391.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 414.81H570.72V438.79H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 414.81L562.38 417.79 569.32 417.79 569.32 438.79 570.72 438.79 570.72 414.81z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 321.38H570.72V333.36H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 321.38L562.38 322.87 569.32 322.87 569.32 333.36 570.72 333.36 570.72 321.38z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 297.64H570.72V309.62H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 297.64L562.38 299.12 569.32 299.12 569.32 309.62 570.72 309.62 570.72 297.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M562.38 273.89H570.72V285.87H562.38z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.38 273.89L562.38 275.38 569.32 275.38 569.32 285.87 570.72 285.87 570.72 273.89z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 344.61H589.61V356.59000000000003H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 344.61L581.27 346.09 588.2 346.09 588.2 356.59 589.61 356.59 589.61 344.61z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 367.79H589.61V379.77000000000004H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 367.79L581.27 369.28 588.2 369.28 588.2 379.77 589.61 379.77 589.61 367.79z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 390.98H589.61V402.96000000000004H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 390.98L581.27 392.46 588.2 392.46 588.2 402.96 589.61 402.96 589.61 390.98z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 414.16H589.61V438.79H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 414.16L581.27 417.22 588.2 417.22 588.2 438.79 589.61 438.79 589.61 414.16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 320.86H589.61V332.84000000000003H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 320.86L581.27 322.35 588.2 322.35 588.2 332.84 589.61 332.84 589.61 320.86z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 297.12H589.61V309.1H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 297.12L581.27 298.6 588.2 298.6 588.2 309.1 589.61 309.1 589.61 297.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M581.27 273.37H589.61V285.35H581.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.27 273.37L581.27 274.86 588.2 274.86 588.2 285.35 589.61 285.35 589.61 273.37z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 345H608.49V356.98H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 345L600.15 346.49 607.09 346.49 607.09 356.98 608.49 356.98 608.49 345z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 368.19H608.49V380.17H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 368.19L600.15 369.67 607.09 369.67 607.09 380.17 608.49 380.17 608.49 368.19z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 391.37H608.49V403.35H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 391.37L600.15 392.86 607.09 392.86 607.09 403.35 608.49 403.35 608.49 391.37z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 414.56H608.49V438.54H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 414.56L600.15 417.53 607.09 417.53 607.09 438.54 608.49 438.54 608.49 414.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 321.26H608.49V333.24H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 321.25L600.15 322.74 607.09 322.74 607.09 333.24 608.49 333.24 608.49 321.25z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 297.51H608.49V309.49H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 297.51L600.15 299 607.09 299 607.09 309.49 608.49 309.49 608.49 297.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 273.76H608.49V285.74H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 273.76L600.15 275.25 607.09 275.25 607.09 285.74 608.49 285.74 608.49 273.76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M600.15 253.52H608.49V265.5H600.15z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.15 253.52L600.15 255.01 607.09 255.01 607.09 265.5 608.49 265.5 608.49 253.52z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.24 277.59H544.16V289.57H541.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.24 289.56H544.57V291.37H539.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.24 300.41H544.16V312.39000000000004H541.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.24 312.39H544.57V314.2H539.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.24 323.23H544.16V335.21000000000004H541.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.24 335.21H544.57V337.02H539.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.24 346.06H544.16V358.04H541.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.24 358.04H544.57V359.85H539.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.53 368.28H544.4499999999999V380.26H541.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.53 380.26H544.86V382.07H539.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M541.82 390.51H544.74V402.49H541.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M539.82 402.49H545.1500000000001V404.3H539.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M542.11 412.74H545.03V424.72H542.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M540.11 424.72H545.44V426.53000000000003H540.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.31 277.59H535.2299999999999V289.57H532.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.31 289.56H535.64V291.37H530.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.31 300.41H535.2299999999999V312.39000000000004H532.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.31 312.39H535.64V314.2H530.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.31 323.23H535.2299999999999V335.21000000000004H532.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.31 335.21H535.64V337.02H530.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.31 346.06H535.2299999999999V358.04H532.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.31 358.04H535.64V359.85H530.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.6 368.28H535.52V380.26H532.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.6 380.26H535.9300000000001V382.07H530.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M532.89 390.51H535.81V402.49H532.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M530.89 402.49H536.22V404.3H530.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M533.18 412.74H536.0999999999999V424.72H533.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M531.18 424.72H536.51V426.53000000000003H531.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.46 438.79L525.23 438.79 525.23 273.66 552.06 260.58z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M300.95 269.81H380.15999999999997V483.26H300.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 277.93H336.93V285.41H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 277.93L331.73 278.86 336.05 278.86 336.05 285.41 336.93 285.41 336.93 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 277.93H344.90999999999997V285.41H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 277.93L339.71 278.86 344.03 278.86 344.03 285.41 344.91 285.41 344.91 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 277.93H352.89V285.41H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 277.93L347.69 278.86 352.01 278.86 352.01 285.41 352.89 285.41 352.89 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 277.93H360.87V285.41H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 277.93L355.67 278.86 360 278.86 360 285.41 360.87 285.41 360.87 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 277.93H368.84999999999997V285.41H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 277.93L363.65 278.86 367.98 278.86 367.98 285.41 368.86 285.41 368.86 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 277.93H376.83V285.41H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 277.93L371.63 278.86 375.96 278.86 375.96 285.41 376.84 285.41 376.84 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 277.93H309.46999999999997V285.41H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 277.93L304.27 278.86 308.6 278.86 308.6 285.41 309.48 285.41 309.48 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 277.93H317.45V285.41H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 277.93L312.25 278.86 316.58 278.86 316.58 285.41 317.46 285.41 317.46 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 277.93H325.43V285.41H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 277.93L320.23 278.86 324.56 278.86 324.56 285.41 325.44 285.41 325.44 277.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 289.03H336.93V296.51H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 289.03L331.73 289.96 336.05 289.96 336.05 296.51 336.93 296.51 336.93 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 289.03H344.90999999999997V296.51H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 289.03L339.71 289.96 344.03 289.96 344.03 296.51 344.91 296.51 344.91 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 289.03H352.89V296.51H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 289.03L347.69 289.96 352.01 289.96 352.01 296.51 352.89 296.51 352.89 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 289.03H360.87V296.51H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 289.03L355.67 289.96 360 289.96 360 296.51 360.87 296.51 360.87 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 289.03H368.84999999999997V296.51H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 289.03L363.65 289.96 367.98 289.96 367.98 296.51 368.86 296.51 368.86 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 289.03H376.83V296.51H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 289.03L371.63 289.96 375.96 289.96 375.96 296.51 376.84 296.51 376.84 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 289.03H309.46999999999997V296.51H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 289.03L304.27 289.96 308.6 289.96 308.6 296.51 309.48 296.51 309.48 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 289.03H317.45V296.51H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 289.03L312.25 289.96 316.58 289.96 316.58 296.51 317.46 296.51 317.46 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 289.03H325.43V296.51H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 289.03L320.23 289.96 324.56 289.96 324.56 296.51 325.44 296.51 325.44 289.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 300.13H336.93V307.61H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 300.13L331.73 301.06 336.05 301.06 336.05 307.61 336.93 307.61 336.93 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 300.13H344.90999999999997V307.61H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 300.13L339.71 301.06 344.03 301.06 344.03 307.61 344.91 307.61 344.91 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 300.13H352.89V307.61H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 300.13L347.69 301.06 352.01 301.06 352.01 307.61 352.89 307.61 352.89 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 300.13H360.87V307.61H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 300.13L355.67 301.06 360 301.06 360 307.61 360.87 307.61 360.87 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 300.13H368.84999999999997V307.61H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 300.13L363.65 301.06 367.98 301.06 367.98 307.61 368.86 307.61 368.86 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 300.13H376.83V307.61H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 300.13L371.63 301.06 375.96 301.06 375.96 307.61 376.84 307.61 376.84 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 300.13H309.46999999999997V307.61H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 300.13L304.27 301.06 308.6 301.06 308.6 307.61 309.48 307.61 309.48 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 300.13H317.45V307.61H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 300.13L312.25 301.06 316.58 301.06 316.58 307.61 317.46 307.61 317.46 300.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 300.13H325.43V307.61H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 300.13L320.23 301.06 324.56 301.06 324.56 307.61 325.44 307.61 325.44 300.13z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 277.93H309.46999999999997V285.41H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 277.93L304.27 278.86 308.6 278.86 308.6 285.41 309.48 285.41 309.48 277.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.25 277.93H317.45V285.41H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.25 277.93L312.25 278.86 316.58 278.86 316.58 285.41 317.46 285.41 317.46 277.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 277.93H325.43V285.41H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 277.93L320.23 278.86 324.56 278.86 324.56 285.41 325.44 285.41 325.44 277.93z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 289.03H309.46999999999997V296.51H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 289.03L304.27 289.96 308.6 289.96 308.6 296.51 309.48 296.51 309.48 289.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.25 289.03H317.45V296.51H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M312.25 289.03L312.25 289.96 316.58 289.96 316.58 296.51 317.46 296.51 317.46 289.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 289.03H325.43V296.51H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 289.03L320.23 289.96 324.56 289.96 324.56 296.51 325.44 296.51 325.44 289.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 300.13H309.46999999999997V307.61H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.27 300.13L304.27 301.06 308.6 301.06 308.6 307.61 309.48 307.61 309.48 300.13z"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 300.13H325.43V307.61H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.23 300.13L320.23 301.06 324.56 301.06 324.56 307.61 325.44 307.61 325.44 300.13z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 311.23H336.93V318.71000000000004H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 311.23L331.73 312.16 336.05 312.16 336.05 318.71 336.93 318.71 336.93 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 311.23H344.90999999999997V318.71000000000004H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 311.23L339.71 312.16 344.03 312.16 344.03 318.71 344.91 318.71 344.91 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 311.23H352.89V318.71000000000004H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 311.23L347.69 312.16 352.01 312.16 352.01 318.71 352.89 318.71 352.89 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 311.23H360.87V318.71000000000004H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 311.23L355.67 312.16 360 312.16 360 318.71 360.87 318.71 360.87 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 311.23H368.84999999999997V318.71000000000004H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 311.23L363.65 312.16 367.98 312.16 367.98 318.71 368.86 318.71 368.86 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 311.23H376.83V318.71000000000004H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 311.23L371.63 312.16 375.96 312.16 375.96 318.71 376.84 318.71 376.84 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 311.23H309.46999999999997V318.71000000000004H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 311.23L304.27 312.16 308.6 312.16 308.6 318.71 309.48 318.71 309.48 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 311.23H317.45V318.71000000000004H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 311.23L312.25 312.16 316.58 312.16 316.58 318.71 317.46 318.71 317.46 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 311.23H325.43V318.71000000000004H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 311.23L320.23 312.16 324.56 312.16 324.56 318.71 325.44 318.71 325.44 311.23z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 322.33H336.93V329.81H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 322.33L331.73 323.26 336.05 323.26 336.05 329.81 336.93 329.81 336.93 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 322.33H344.90999999999997V329.81H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 322.33L339.71 323.26 344.03 323.26 344.03 329.81 344.91 329.81 344.91 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 322.33H352.89V329.81H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 322.33L347.69 323.26 352.01 323.26 352.01 329.81 352.89 329.81 352.89 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 322.33H360.87V329.81H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 322.33L355.67 323.26 360 323.26 360 329.81 360.87 329.81 360.87 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 322.33H368.84999999999997V329.81H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 322.33L363.65 323.26 367.98 323.26 367.98 329.81 368.86 329.81 368.86 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 322.33H376.83V329.81H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 322.33L371.63 323.26 375.96 323.26 375.96 329.81 376.84 329.81 376.84 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 322.33H309.46999999999997V329.81H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 322.33L304.27 323.26 308.6 323.26 308.6 329.81 309.48 329.81 309.48 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 322.33H317.45V329.81H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 322.33L312.25 323.26 316.58 323.26 316.58 329.81 317.46 329.81 317.46 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 322.33H325.43V329.81H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 322.33L320.23 323.26 324.56 323.26 324.56 329.81 325.44 329.81 325.44 322.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 333.43H336.93V340.91H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 333.43L331.73 334.36 336.05 334.36 336.05 340.91 336.93 340.91 336.93 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 333.43H344.90999999999997V340.91H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 333.43L339.71 334.36 344.03 334.36 344.03 340.91 344.91 340.91 344.91 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 333.43H352.89V340.91H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 333.43L347.69 334.36 352.01 334.36 352.01 340.91 352.89 340.91 352.89 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 333.43H360.87V340.91H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 333.43L355.67 334.36 360 334.36 360 340.91 360.87 340.91 360.87 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 333.43H368.84999999999997V340.91H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 333.43L363.65 334.36 367.98 334.36 367.98 340.91 368.86 340.91 368.86 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 333.43H376.83V340.91H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 333.43L371.63 334.36 375.96 334.36 375.96 340.91 376.84 340.91 376.84 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 333.43H309.46999999999997V340.91H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 333.43L304.27 334.36 308.6 334.36 308.6 340.91 309.48 340.91 309.48 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 333.43H317.45V340.91H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 333.43L312.25 334.36 316.58 334.36 316.58 340.91 317.46 340.91 317.46 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 333.43H325.43V340.91H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 333.43L320.23 334.36 324.56 334.36 324.56 340.91 325.44 340.91 325.44 333.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 349.84H336.93V357.32H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 349.84L331.73 350.77 336.05 350.77 336.05 357.32 336.93 357.32 336.93 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 349.84H344.90999999999997V357.32H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 349.84L339.71 350.77 344.03 350.77 344.03 357.32 344.91 357.32 344.91 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 349.84H352.89V357.32H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 349.84L347.69 350.77 352.01 350.77 352.01 357.32 352.89 357.32 352.89 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 349.84H360.87V357.32H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 349.84L355.67 350.77 360 350.77 360 357.32 360.87 357.32 360.87 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 349.84H368.84999999999997V357.32H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 349.84L363.65 350.77 367.98 350.77 367.98 357.32 368.86 357.32 368.86 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 349.84H376.83V357.32H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 349.84L371.63 350.77 375.96 350.77 375.96 357.32 376.84 357.32 376.84 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 349.84H309.46999999999997V357.32H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 349.84L304.27 350.77 308.6 350.77 308.6 357.32 309.48 357.32 309.48 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 349.84H317.45V357.32H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 349.84L312.25 350.77 316.58 350.77 316.58 357.32 317.46 357.32 317.46 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 349.84H325.43V357.32H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 349.84L320.23 350.77 324.56 350.77 324.56 357.32 325.44 357.32 325.44 349.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 360.56H336.93V368.04H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 360.56L331.73 361.49 336.05 361.49 336.05 368.04 336.93 368.04 336.93 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 360.56H344.90999999999997V368.04H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 360.56L339.71 361.49 344.03 361.49 344.03 368.04 344.91 368.04 344.91 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 360.56H352.89V368.04H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 360.56L347.69 361.49 352.01 361.49 352.01 368.04 352.89 368.04 352.89 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 360.56H360.87V368.04H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 360.56L355.67 361.49 360 361.49 360 368.04 360.87 368.04 360.87 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 360.56H368.84999999999997V368.04H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 360.56L363.65 361.49 367.98 361.49 367.98 368.04 368.86 368.04 368.86 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 360.56H376.83V368.04H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 360.56L371.63 361.49 375.96 361.49 375.96 368.04 376.84 368.04 376.84 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 360.56H309.46999999999997V368.04H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 360.56L304.27 361.49 308.6 361.49 308.6 368.04 309.48 368.04 309.48 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 360.56H317.45V368.04H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 360.56L312.25 361.49 316.58 361.49 316.58 368.04 317.46 368.04 317.46 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 360.56H325.43V368.04H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 360.56L320.23 361.49 324.56 361.49 324.56 368.04 325.44 368.04 325.44 360.56z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 371.28H336.93V378.76H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 371.28L331.73 372.21 336.05 372.21 336.05 378.75 336.93 378.75 336.93 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 371.28H344.90999999999997V378.76H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 371.28L339.71 372.21 344.03 372.21 344.03 378.75 344.91 378.75 344.91 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 371.28H352.89V378.76H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 371.28L347.69 372.21 352.01 372.21 352.01 378.75 352.89 378.75 352.89 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 371.28H360.87V378.76H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 371.28L355.67 372.21 360 372.21 360 378.75 360.87 378.75 360.87 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 371.28H368.84999999999997V378.76H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 371.28L363.65 372.21 367.98 372.21 367.98 378.75 368.86 378.75 368.86 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 371.28H376.83V378.76H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 371.28L371.63 372.21 375.96 372.21 375.96 378.75 376.84 378.75 376.84 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 371.28H309.46999999999997V378.76H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 371.28L304.27 372.21 308.6 372.21 308.6 378.75 309.48 378.75 309.48 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 371.28H317.45V378.76H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 371.28L312.25 372.21 316.58 372.21 316.58 378.75 317.46 378.75 317.46 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 371.28H325.43V378.76H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 371.28L320.23 372.21 324.56 372.21 324.56 378.75 325.44 378.75 325.44 371.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 382H336.93V389.48H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 382L331.73 382.93 336.05 382.93 336.05 389.47 336.93 389.47 336.93 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 382H344.90999999999997V389.48H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 382L339.71 382.93 344.03 382.93 344.03 389.47 344.91 389.47 344.91 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 382H352.89V389.48H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 382L347.69 382.93 352.01 382.93 352.01 389.47 352.89 389.47 352.89 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 382H360.87V389.48H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 382L355.67 382.93 360 382.93 360 389.47 360.87 389.47 360.87 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 382H368.84999999999997V389.48H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 382L363.65 382.93 367.98 382.93 367.98 389.47 368.86 389.47 368.86 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 382H376.83V389.48H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 382L371.63 382.93 375.96 382.93 375.96 389.47 376.84 389.47 376.84 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 382H309.46999999999997V389.48H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 382L304.27 382.93 308.6 382.93 308.6 389.47 309.48 389.47 309.48 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 382H317.45V389.48H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 382L312.25 382.93 316.58 382.93 316.58 389.47 317.46 389.47 317.46 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 382H325.43V389.48H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 382L320.23 382.93 324.56 382.93 324.56 389.47 325.44 389.47 325.44 382z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 392.72H336.93V400.20000000000005H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 392.72L331.73 393.64 336.05 393.64 336.05 400.19 336.93 400.19 336.93 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 392.72H344.90999999999997V400.20000000000005H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 392.72L339.71 393.64 344.03 393.64 344.03 400.19 344.91 400.19 344.91 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 392.72H352.89V400.20000000000005H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 392.72L347.69 393.64 352.01 393.64 352.01 400.19 352.89 400.19 352.89 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 392.72H360.87V400.20000000000005H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 392.72L355.67 393.64 360 393.64 360 400.19 360.87 400.19 360.87 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 392.72H368.84999999999997V400.20000000000005H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 392.72L363.65 393.64 367.98 393.64 367.98 400.19 368.86 400.19 368.86 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 392.72H376.83V400.20000000000005H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 392.72L371.63 393.64 375.96 393.64 375.96 400.19 376.84 400.19 376.84 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 392.72H309.46999999999997V400.20000000000005H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 392.72L304.27 393.64 308.6 393.64 308.6 400.19 309.48 400.19 309.48 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 392.72H317.45V400.20000000000005H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 392.72L312.25 393.64 316.58 393.64 316.58 400.19 317.46 400.19 317.46 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 392.72H325.43V400.20000000000005H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 392.72L320.23 393.64 324.56 393.64 324.56 400.19 325.44 400.19 325.44 392.72z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 403.44H336.93V410.92H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 403.44L331.73 404.36 336.05 404.36 336.05 410.91 336.93 410.91 336.93 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 403.44H344.90999999999997V410.92H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 403.44L339.71 404.36 344.03 404.36 344.03 410.91 344.91 410.91 344.91 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 403.44H352.89V410.92H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 403.44L347.69 404.36 352.01 404.36 352.01 410.91 352.89 410.91 352.89 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 403.44H360.87V410.92H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 403.44L355.67 404.36 360 404.36 360 410.91 360.87 410.91 360.87 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 403.44H368.84999999999997V410.92H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 403.44L363.65 404.36 367.98 404.36 367.98 410.91 368.86 410.91 368.86 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 403.44H376.83V410.92H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 403.44L371.63 404.36 375.96 404.36 375.96 410.91 376.84 410.91 376.84 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 403.44H309.46999999999997V410.92H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 403.44L304.27 404.36 308.6 404.36 308.6 410.91 309.48 410.91 309.48 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 403.44H317.45V410.92H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 403.44L312.25 404.36 316.58 404.36 316.58 410.91 317.46 410.91 317.46 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 403.44H325.43V410.92H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 403.44L320.23 404.36 324.56 404.36 324.56 410.91 325.44 410.91 325.44 403.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 417.49H336.93V424.97H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 417.49L331.73 418.41 336.05 418.41 336.05 424.96 336.93 424.96 336.93 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 417.49H344.90999999999997V424.97H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 417.49L339.71 418.41 344.03 418.41 344.03 424.96 344.91 424.96 344.91 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 417.49H352.89V424.97H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 417.49L347.69 418.41 352.01 418.41 352.01 424.96 352.89 424.96 352.89 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 417.49H360.87V424.97H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 417.49L355.67 418.41 360 418.41 360 424.96 360.87 424.96 360.87 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 417.49H368.84999999999997V424.97H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 417.49L363.65 418.41 367.98 418.41 367.98 424.96 368.86 424.96 368.86 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 417.49H376.83V424.97H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 417.49L371.63 418.41 375.96 418.41 375.96 424.96 376.84 424.96 376.84 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 417.49H309.46999999999997V424.97H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 417.49L304.27 418.41 308.6 418.41 308.6 424.96 309.48 424.96 309.48 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 417.49H317.45V424.97H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 417.49L312.25 418.41 316.58 418.41 316.58 424.96 317.46 424.96 317.46 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 417.49H325.43V424.97H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 417.49L320.23 418.41 324.56 418.41 324.56 424.96 325.44 424.96 325.44 417.49z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 428.21H336.93V435.69H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 428.21L331.73 429.13 336.05 429.13 336.05 435.68 336.93 435.68 336.93 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 428.21H344.90999999999997V435.69H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 428.21L339.71 429.13 344.03 429.13 344.03 435.68 344.91 435.68 344.91 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 428.21H352.89V435.69H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 428.21L347.69 429.13 352.01 429.13 352.01 435.68 352.89 435.68 352.89 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 428.21H360.87V435.69H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 428.21L355.67 429.13 360 429.13 360 435.68 360.87 435.68 360.87 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 428.21H368.84999999999997V435.69H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 428.21L363.65 429.13 367.98 429.13 367.98 435.68 368.86 435.68 368.86 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 428.21H376.83V435.69H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 428.21L371.63 429.13 375.96 429.13 375.96 435.68 376.84 435.68 376.84 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 428.21H309.46999999999997V435.69H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 428.21L304.27 429.13 308.6 429.13 308.6 435.68 309.48 435.68 309.48 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 428.21H317.45V435.69H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 428.21L312.25 429.13 316.58 429.13 316.58 435.68 317.46 435.68 317.46 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 428.21H325.43V435.69H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 428.21L320.23 429.13 324.56 429.13 324.56 435.68 325.44 435.68 325.44 428.21z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 438.93H336.93V446.41H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 438.93L331.73 439.85 336.05 439.85 336.05 446.4 336.93 446.4 336.93 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 438.93H344.90999999999997V446.41H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 438.93L339.71 439.85 344.03 439.85 344.03 446.4 344.91 446.4 344.91 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 438.93H352.89V446.41H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 438.93L347.69 439.85 352.01 439.85 352.01 446.4 352.89 446.4 352.89 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 438.93H360.87V446.41H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 438.93L355.67 439.85 360 439.85 360 446.4 360.87 446.4 360.87 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 438.93H368.84999999999997V446.41H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 438.93L363.65 439.85 367.98 439.85 367.98 446.4 368.86 446.4 368.86 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 438.93H376.83V446.41H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 438.93L371.63 439.85 375.96 439.85 375.96 446.4 376.84 446.4 376.84 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 438.93H309.46999999999997V446.41H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 438.93L304.27 439.85 308.6 439.85 308.6 446.4 309.48 446.4 309.48 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 438.93H317.45V446.41H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 438.93L312.25 439.85 316.58 439.85 316.58 446.4 317.46 446.4 317.46 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 438.93H325.43V446.41H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 438.93L320.23 439.85 324.56 439.85 324.56 446.4 325.44 446.4 325.44 438.93z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 449.64H336.93V457.12H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 449.64L331.73 450.57 336.05 450.57 336.05 457.12 336.93 457.12 336.93 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 449.64H344.90999999999997V457.12H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 449.64L339.71 450.57 344.03 450.57 344.03 457.12 344.91 457.12 344.91 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 449.64H352.89V457.12H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 449.64L347.69 450.57 352.01 450.57 352.01 457.12 352.89 457.12 352.89 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 449.64H360.87V457.12H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 449.64L355.67 450.57 360 450.57 360 457.12 360.87 457.12 360.87 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 449.64H368.84999999999997V457.12H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 449.64L363.65 450.57 367.98 450.57 367.98 457.12 368.86 457.12 368.86 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 449.64H376.83V457.12H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 449.64L371.63 450.57 375.96 450.57 375.96 457.12 376.84 457.12 376.84 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 449.64H309.46999999999997V457.12H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 449.64L304.27 450.57 308.6 450.57 308.6 457.12 309.48 457.12 309.48 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 449.64H317.45V457.12H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 449.64L312.25 450.57 316.58 450.57 316.58 457.12 317.46 457.12 317.46 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 449.64H325.43V457.12H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 449.64L320.23 450.57 324.56 450.57 324.56 457.12 325.44 457.12 325.44 449.64z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 460.36H336.93V467.84000000000003H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 460.36L331.73 461.29 336.05 461.29 336.05 467.84 336.93 467.84 336.93 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 460.36H344.90999999999997V467.84000000000003H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 460.36L339.71 461.29 344.03 461.29 344.03 467.84 344.91 467.84 344.91 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 460.36H352.89V467.84000000000003H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 460.36L347.69 461.29 352.01 461.29 352.01 467.84 352.89 467.84 352.89 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 460.36H360.87V467.84000000000003H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 460.36L355.67 461.29 360 461.29 360 467.84 360.87 467.84 360.87 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 460.36H368.84999999999997V467.84000000000003H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 460.36L363.65 461.29 367.98 461.29 367.98 467.84 368.86 467.84 368.86 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 460.36H376.83V467.84000000000003H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 460.36L371.63 461.29 375.96 461.29 375.96 467.84 376.84 467.84 376.84 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 460.36H309.46999999999997V467.84000000000003H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 460.36L304.27 461.29 308.6 461.29 308.6 467.84 309.48 467.84 309.48 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 460.36H317.45V467.84000000000003H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 460.36L312.25 461.29 316.58 461.29 316.58 467.84 317.46 467.84 317.46 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 460.36H325.43V467.84000000000003H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 460.36L320.23 461.29 324.56 461.29 324.56 467.84 325.44 467.84 325.44 460.36z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M331.73 471.08H336.93V478.56H331.73z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.73 471.08L331.73 472.01 336.05 472.01 336.05 478.56 336.93 478.56 336.93 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M339.71 471.08H344.90999999999997V478.56H339.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.71 471.08L339.71 472.01 344.03 472.01 344.03 478.56 344.91 478.56 344.91 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M347.69 471.08H352.89V478.56H347.69z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.69 471.08L347.69 472.01 352.01 472.01 352.01 478.56 352.89 478.56 352.89 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M355.67 471.08H360.87V478.56H355.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67 471.08L355.67 472.01 360 472.01 360 478.56 360.87 478.56 360.87 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M363.65 471.08H368.84999999999997V478.56H363.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.65 471.08L363.65 472.01 367.98 472.01 367.98 478.56 368.86 478.56 368.86 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M371.63 471.08H376.83V478.56H371.63z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.63 471.08L371.63 472.01 375.96 472.01 375.96 478.56 376.84 478.56 376.84 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M304.27 471.08H309.46999999999997V478.56H304.27z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 471.08L304.27 472.01 308.6 472.01 308.6 478.56 309.48 478.56 309.48 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M312.25 471.08H317.45V478.56H312.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.25 471.08L312.25 472.01 316.58 472.01 316.58 478.56 317.46 478.56 317.46 471.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M320.23 471.08H325.43V478.56H320.23z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.23 471.08L320.23 472.01 324.56 472.01 324.56 478.56 325.44 478.56 325.44 471.08z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.73 277.93H336.93V285.41H331.73z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M339.71 277.93H344.90999999999997V285.41H339.71z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M347.69 277.93H352.89V285.41H347.69z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M355.67 277.93H360.87V285.41H355.67z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M363.65 277.93H368.84999999999997V285.41H363.65z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M371.63 277.93H376.83V285.41H371.63z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.73 289.03H336.93V296.51H331.73z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M339.71 289.03H344.90999999999997V296.51H339.71z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M347.69 289.03H352.89V296.51H347.69z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M355.67 289.03H360.87V296.51H355.67z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M363.65 289.03H368.84999999999997V296.51H363.65z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M371.63 289.03H376.83V296.51H371.63z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.73 300.13H336.93V307.61H331.73z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M339.71 300.13H344.90999999999997V307.61H339.71z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M363.65 300.13H368.84999999999997V307.61H363.65z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M331.73 311.23H336.93V318.71000000000004H331.73z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M363.65 311.23H368.84999999999997V318.71000000000004H363.65z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.95 269.81H328.03V483.28H300.95z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M286.47 358.91H331.96000000000004V483.07000000000005H286.47z",
    transform: "rotate(180 309.21 420.985)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M263.23 358.91H286.46000000000004V483.07000000000005H263.23z",
    transform: "rotate(180 274.85 420.985)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M293.18 370.96H302.54V383.62H293.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 370.96L293.18 372.53 300.96 372.53 300.96 383.62 302.54 383.62 302.54 370.96z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 383.62H303.08V386.19H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 368.31H303.08V370.88H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 383.62H324.09999999999997V386.19H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 368.31H324.09999999999997V370.88H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M314.2 370.96H323.56V383.62H314.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.2 370.96L314.2 372.53 321.98 372.53 321.98 383.62 323.56 383.62 323.56 370.96z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M293.18 394.44H302.54V407.1H293.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 394.44L293.18 396.01 300.96 396.01 300.96 407.11 302.54 407.11 302.54 394.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 407.11H303.08V409.68H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 391.8H303.08V394.37H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 407.11H324.09999999999997V409.68H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 391.8H324.09999999999997V394.37H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M314.2 394.44H323.56V407.1H314.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.2 394.44L314.2 396.01 321.98 396.01 321.98 407.11 323.56 407.11 323.56 394.44z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M293.18 418.76H302.54V431.42H293.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 418.76L293.18 420.33 300.96 420.33 300.96 431.42 302.54 431.42 302.54 418.76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 431.42H303.08V433.99H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 416.11H303.08V418.68H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 431.42H324.09999999999997V433.99H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 416.11H324.09999999999997V418.68H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M314.2 418.76H323.56V431.42H314.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.2 418.76L314.2 420.33 321.98 420.33 321.98 431.42 323.56 431.42 323.56 418.76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M293.18 442.91H302.54V455.57000000000005H293.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 442.91L293.18 444.48 300.96 444.48 300.96 455.57 302.54 455.57 302.54 442.91z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 455.57H303.08V458.14H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.18 440.26H303.08V442.83H293.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 455.57H324.09999999999997V458.14H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.2 440.26H324.09999999999997V442.83H314.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M314.2 442.91H323.56V455.57000000000005H314.2z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.2 442.91L314.2 444.48 321.98 444.48 321.98 455.57 323.56 455.57 323.56 442.91z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.09 370.54H280.36999999999995V383.20000000000005H277.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.85 383.21H280.84000000000003V385.12H274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.32 370.54H271.59999999999997V383.20000000000005H268.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.08 383.21H272.07V385.12H266.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.09 394.67H280.36999999999995V407.33000000000004H277.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.85 407.33H280.84000000000003V409.24H274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.32 394.67H271.59999999999997V407.33000000000004H268.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.08 407.33H272.07V409.24H266.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.09 418.79H280.36999999999995V431.45000000000005H277.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.85 431.45H280.84000000000003V433.36H274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.32 418.79H271.59999999999997V431.45000000000005H268.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.08 431.45H272.07V433.36H266.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M293.18 463.08H302.54V483.06H293.18z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.18 463.08L293.18 464.58 300.96 464.58 300.96 483.06 302.54 483.06 302.54 463.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M314.48 463.08H323.84000000000003V483.06H314.48z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.48 463.08L314.48 464.58 322.26 464.58 322.26 483.06 323.83 483.06 323.83 463.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.09 442.91H280.36999999999995V455.57000000000005H277.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.85 455.57H280.84000000000003V457.48H274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.32 442.91H271.59999999999997V455.57000000000005H268.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.08 455.57H272.07V457.48H266.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M277.09 464.11H280.36999999999995V476.77000000000004H277.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M274.85 476.77H280.84000000000003V478.68H274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M268.32 464.11H271.59999999999997V476.77000000000004H268.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M266.08 476.77H272.07V478.68H266.08z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.57 358.91H286.46999999999997V483.07000000000005H262.57z",
    transform: "rotate(180 274.52 420.985)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M529.16 431.24H627.9599999999999V483.5H529.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M527.9 431.24H630.04V436.12H527.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M542.38 444.03H546.51V473.85999999999996H542.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M534.43 444.03H538.56V473.85999999999996H534.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M529.16 473.77H627.9599999999999V483.51H529.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M561.78 462.21H571.62V483.5H561.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M561.78 445.51H567.62V453.02H561.78z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.78 445.51L561.78 446.44 566.63 446.44 566.63 453.02 567.61 453.02 567.61 445.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M578.54 445.51H584.38V453.02H578.54z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.54 445.51L578.54 446.44 583.39 446.44 583.39 453.02 584.38 453.02 584.38 445.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M596.49 445.51H602.33V453.02H596.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.49 445.51L596.49 446.44 601.34 446.44 601.34 453.02 602.33 453.02 602.33 445.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M614.44 445.51H620.2800000000001V453.02H614.44z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.44 445.51L614.44 446.44 619.29 446.44 619.29 453.02 620.28 453.02 620.28 445.51z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M578.54 458.94H584.38V466.45H578.54z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.54 458.94L578.54 459.87 583.39 459.87 583.39 466.45 584.38 466.45 584.38 458.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M596.49 458.94H602.33V466.45H596.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.49 458.94L596.49 459.87 601.34 459.87 601.34 466.45 602.33 466.45 602.33 458.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M614.44 458.94H620.2800000000001V466.45H614.44z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.44 458.94L614.44 459.87 619.29 459.87 619.29 466.45 620.28 466.45 620.28 458.94z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.16 436.13H555.5V483.51H529.16z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M414.51 328.72H528.96V483.28000000000003H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M439.66 339.73H448.07000000000005V351.81H439.66z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.66 339.73L439.66 341.23 446.64 341.23 446.64 351.81 448.06 351.81 448.06 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M455.09 339.73H463.5V351.81H455.09z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.09 339.73L455.09 341.23 462.08 341.23 462.08 351.81 463.5 351.81 463.5 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M470.53 339.73H478.94V351.81H470.53z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.53 339.73L470.53 341.23 477.52 341.23 477.52 351.81 478.94 351.81 478.94 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M485.97 339.73H494.38000000000005V351.81H485.97z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.97 339.73L485.97 341.23 492.95 341.23 492.95 351.81 494.37 351.81 494.37 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M501.4 339.73H509.81V351.81H501.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.4 339.73L501.4 341.23 508.39 341.23 508.39 351.81 509.81 351.81 509.81 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M516.84 339.73H525.25V351.81H516.84z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.84 339.73L516.84 341.23 523.83 341.23 523.83 351.81 525.25 351.81 525.25 339.73z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M440.39 369.08H448.8V381.15999999999997H440.39z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.39 369.08L440.39 370.57 447.38 370.57 447.38 381.15 448.79 381.15 448.79 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M455.82 369.08H464.23V381.15999999999997H455.82z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.82 369.08L455.82 370.57 462.81 370.57 462.81 381.15 464.23 381.15 464.23 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M471.26 369.08H479.67V381.15999999999997H471.26z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.26 369.08L471.26 370.57 478.25 370.57 478.25 381.15 479.67 381.15 479.67 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M486.7 369.08H495.11V381.15999999999997H486.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.7 369.08L486.7 370.57 493.69 370.57 493.69 381.15 495.1 381.15 495.1 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M502.13 369.08H510.54V381.15999999999997H502.13z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.13 369.08L502.13 370.57 509.12 370.57 509.12 381.15 510.54 381.15 510.54 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M517.57 369.08H525.98V381.15999999999997H517.57z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.57 369.08L517.57 370.57 524.56 370.57 524.56 381.15 525.98 381.15 525.98 369.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M439.49 398.33H447.90000000000003V410.40999999999997H439.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.49 398.33L439.49 399.83 446.48 399.83 446.48 410.41 447.9 410.41 447.9 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M454.93 398.33H463.34000000000003V410.40999999999997H454.93z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.93 398.33L454.93 399.83 461.92 399.83 461.92 410.41 463.34 410.41 463.34 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M470.37 398.33H478.78000000000003V410.40999999999997H470.37z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.37 398.33L470.37 399.83 477.36 399.83 477.36 410.41 478.77 410.41 478.77 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M485.8 398.33H494.21000000000004V410.40999999999997H485.8z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.8 398.33L485.8 399.83 492.79 399.83 492.79 410.41 494.21 410.41 494.21 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M501.24 398.33H509.65000000000003V410.40999999999997H501.24z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.24 398.33L501.24 399.83 508.23 399.83 508.23 410.41 509.65 410.41 509.65 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M516.68 398.33H525.0899999999999V410.40999999999997H516.68z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.68 398.33L516.68 399.83 523.66 399.83 523.66 410.41 525.08 410.41 525.08 398.33z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M439.91 427.5H448.32000000000005V439.58H439.91z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.91 427.5L439.91 429 446.9 429 446.9 439.58 448.31 439.58 448.31 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M455.35 427.5H463.76000000000005V439.58H455.35z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.35 427.5L455.35 429 462.33 429 462.33 439.58 463.75 439.58 463.75 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M470.78 427.5H479.19V439.58H470.78z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.78 427.5L470.78 429 477.77 429 477.77 439.58 479.19 439.58 479.19 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M442.41 461.03H467.28000000000003V483.27H442.41z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.41 461.04L442.41 463.79 464.67 463.79 464.67 483.28 467.28 483.28 467.28 461.04z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M472.59 461.03H488.07V483.27H472.59z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.59 461.04L472.59 463.79 485.46 463.79 485.46 483.28 488.07 483.28 488.07 461.04z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M508.7 461.03H524.18V483.27H508.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.7 461.04L508.7 463.79 521.57 463.79 521.57 483.28 524.19 483.28 524.19 461.04z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M486.22 427.5H494.63000000000005V439.58H486.22z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.22 427.5L486.22 429 493.21 429 493.21 439.58 494.63 439.58 494.63 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M501.66 427.5H510.07000000000005V439.58H501.66z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.66 427.5L501.66 429 508.64 429 508.64 439.58 510.06 439.58 510.06 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M517.09 427.5H525.5V439.58H517.09z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.09 427.5L517.09 429 524.08 429 524.08 439.58 525.5 439.58 525.5 427.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M414.51 326.12H528.96V331.31H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M414.51 356.71H528.96V361.9H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M414.51 385.97H528.96V391.16H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M414.51 415.23H528.96V420.42H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M414.51 445.07H528.96V450.26H414.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M419.42 338.79H422.48V351.33000000000004H419.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M428.4 338.79H431.46V351.33000000000004H428.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M419.59 366.72H422.65V379.26000000000005H419.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M428.7 366.72H431.76V379.26000000000005H428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M419.53 395.98H422.59V408.52000000000004H419.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M428.64 395.98H431.7V408.52000000000004H428.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M419.12 425.53H422.18V438.07H419.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M427.52 425.53H430.58V438.07H427.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M419.12 461.1H422.18V483.28000000000003H419.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M427.52 461.1H430.58V483.28000000000003H427.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M414.51 446.67H528.96V451.86H414.51z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.51 326.12H434.53999999999996V483.28H414.51z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55 420.42H528.97V422.61H434.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55 451.93H528.97V454.12H434.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55 391.43H528.97V393.62H434.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55 361.9H528.97V364.09H434.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.55 331.31H528.97V333.5H434.55z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.18 462.32H504.81V483.28H493.18z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M443.7 313.93H466.62V326.12H443.7z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.7 313.93H450.96999999999997V326.12H443.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M448.4 439.36a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M463.68 439.36a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479 439.36a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M494.71 439.36a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M510.22 439.36a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M525.73 439.36a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M448.4 410.22a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M463.68 410.22a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479 410.22a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M494.71 410.22a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M510.22 410.22a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M525.73 410.22a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M448.4 381.15a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M463.68 381.15a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479 381.15a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M494.71 381.15a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M510.22 381.15a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M525.73 381.15a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M448.4 351.81a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M463.68 351.81a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M479 351.81a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M494.71 351.81a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M510.22 351.81a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M525.73 351.81a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2633 0 0 1.35546 -64.904 -154.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M338.35 378.03H414.37V483.15999999999997H338.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M370.16 446.15H378.89000000000004V458.69H370.16z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.16 446.15L370.16 447.71 377.42 447.71 377.42 458.69 378.89 458.69 378.89 446.15z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370.16 458.69H381.44V460.17H370.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M370.16 465.95H378.89000000000004V478.49H370.16z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.16 465.95L370.16 467.5 377.42 467.5 377.42 478.49 378.89 478.49 378.89 465.95z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370.16 478.49H381.44V479.97H370.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M370 428.61H378.73V441.15000000000003H370z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370 428.61L370 430.17 377.25 430.17 377.25 441.15 378.73 441.15 378.73 428.61z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370 441.15H381.28V442.63H370z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M369.84 411.07H378.57V423.61H369.84z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.84 411.07L369.84 412.63 377.09 412.63 377.09 423.61 378.56 423.61 378.56 411.07z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M369.84 423.61H381.11999999999995V425.09000000000003H369.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M369.67 393.53H378.40000000000003V406.07H369.67z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.67 393.53L369.67 395.09 376.93 395.09 376.93 406.07 378.4 406.07 378.4 393.53z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M369.67 406.07H380.95V407.55H369.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M392.71 446.15H401.44V458.69H392.71z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.71 446.15L392.71 447.71 399.97 447.71 399.97 458.69 401.44 458.69 401.44 446.15z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392.71 458.69H403.98999999999995V460.17H392.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M392.55 428.61H401.28000000000003V441.15000000000003H392.55z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.55 428.61L392.55 430.17 399.81 430.17 399.81 441.15 401.28 441.15 401.28 428.61z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392.55 441.15H403.83V442.63H392.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M392.39 411.07H401.12V423.61H392.39z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.39 411.07L392.39 412.63 399.64 412.63 399.64 423.61 401.12 423.61 401.12 411.07z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392.39 423.61H403.66999999999996V425.09000000000003H392.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M392.22 393.53H400.95000000000005V406.07H392.22z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.22 393.53L392.22 395.09 399.48 395.09 399.48 406.07 400.95 406.07 400.95 393.53z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M392.22 406.07H403.5V407.55H392.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.77 392.58H347.83V405.12H344.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342.68 405.12H348.26V407.01H342.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.77 411.82H347.83V424.36H344.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342.68 424.36H348.26V426.25H342.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.77 431.06H347.83V443.6H344.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342.68 443.6H348.26V445.49H342.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.77 450.3H347.83V462.84000000000003H344.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342.68 462.84H348.26V464.72999999999996H342.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M344.77 467.73H347.83V480.27000000000004H344.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342.68 480.27H348.26V482.15999999999997H342.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M336.94 372.75H416.38V378.03H336.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M338.24 380.27H414.31V381.83H338.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M391.83 463.78H403.89V483.15H391.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M392.81 464.73H402.84V483.28000000000003H392.81z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.35 378.03H356.57000000000005V483.28H338.35z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.94 372.75H351.4V378.03H336.94z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M146.34 339.32H260.13V483.28H146.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M144.6 336.88H261.59V341.75H144.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M146.34 350.07H260.13V354.08H146.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M146.34 344.91H260.13V346.92H146.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M224.31 353.46H250.69V457.02H224.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M170.67 353.46H197.04999999999998V457.02H170.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M146.34 457.02H261.58V461.03H146.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#18365e",
    d: "M199.08 463.04H219.15V483.11H199.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M227.34 464.48H236.07V477.02000000000004H227.34z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.34 464.48L227.34 466.04 234.59 466.04 234.59 477.02 236.06 477.02 236.06 464.48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M227.34 477.02H238.62V478.5H227.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M246.94 464.48H255.67V477.02000000000004H246.94z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.94 464.48L246.94 466.04 254.2 466.04 254.2 477.02 255.67 477.02 255.67 464.48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M246.94 477.02H258.21999999999997V478.5H246.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M152.65 464.48H161.38V477.02000000000004H152.65z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.66 464.48L152.66 466.04 159.91 466.04 159.91 477.02 161.38 477.02 161.38 464.48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.65 477.02H163.93V478.5H152.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M179.68 465.5H188.41V478.04H179.68z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.68 465.5L179.68 467.05 186.93 467.05 186.93 478.04 188.41 478.04 188.41 465.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.68 478.04H190.96V479.52000000000004H179.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M206.31 437.48H215.04V450.02000000000004H206.31z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.31 437.48L206.31 439.03 213.57 439.03 213.57 450.02 215.04 450.02 215.04 437.48z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M206.31 412.62H215.04V425.16H206.31z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.31 412.62L206.31 414.17 213.57 414.17 213.57 425.16 215.04 425.16 215.04 412.62z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M206.31 387.76H215.04V400.3H206.31z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.31 387.76L206.31 389.31 213.57 389.31 213.57 400.3 215.04 400.3 215.04 387.76z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M206.31 362.9H215.04V375.44H206.31z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M206.31 362.9H215.04V375.44H206.31z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.31 362.9L206.31 364.45 213.57 364.45 213.57 375.44 215.04 375.44 215.04 362.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M179.49 437.71H188.22V450.25H179.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.49 437.71L179.49 439.26 186.75 439.26 186.75 450.25 188.22 450.25 188.22 437.71z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M179.49 412.85H188.22V425.39000000000004H179.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.49 412.85L179.49 414.41 186.75 414.41 186.75 425.39 188.22 425.39 188.22 412.85z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M179.49 387.99H188.22V400.53000000000003H179.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.49 387.99H188.22V400.53000000000003H179.49z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.49 387.99L179.49 389.55 186.75 389.55 186.75 400.53 188.22 400.53 188.22 387.99z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M179.49 363.13H188.22V375.67H179.49z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.49 363.13H188.22V375.67H179.49z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.49 363.13L179.49 364.69 186.75 364.69 186.75 375.68 188.22 375.68 188.22 363.13z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M234.25 437.7H242.98V450.24H234.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.25 437.7L234.25 439.25 241.5 439.25 241.5 450.24 242.98 450.24 242.98 437.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M234.25 412.84H242.98V425.38H234.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.25 412.84L234.25 414.4 241.5 414.4 241.5 425.38 242.98 425.38 242.98 412.84z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M234.25 387.98H242.98V400.52000000000004H234.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234.25 387.98H242.98V400.52000000000004H234.25z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.25 387.98L234.25 389.54 241.5 389.54 241.5 400.52 242.98 400.52 242.98 387.98z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M234.25 363.12H242.98V375.66H234.25z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234.25 363.12H242.98V375.66H234.25z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.25 363.12L234.25 364.68 241.5 364.68 241.5 375.67 242.98 375.67 242.98 363.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153.49 363.86H156.55V376.40000000000003H153.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.4 376.41H156.98000000000002V378.3H151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153.49 387.76H156.55V400.3H153.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.4 400.3H156.98000000000002V402.19H151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153.49 411.65H156.55V424.19H153.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.4 424.19H156.98000000000002V426.08H151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M153.49 435.54H156.55V448.08000000000004H153.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.4 448.08H156.98000000000002V449.96999999999997H151.4z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.34 341.75H167.08V483.27H146.34z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M201.31 465H217.22V483.11H201.31z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.6 336.88H163.7V341.75H144.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M188 376a18.14 18.14 0 01-4.29.26 18.14 18.14 0 01-4.29-.26 17.53 17.53 0 014.29-.26 17.53 17.53 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M215.21 375.67a17.22 17.22 0 01-4.29.27 17.22 17.22 0 01-4.29-.27 18.14 18.14 0 014.29-.26 18.14 18.14 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.14 375.9a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.14 400.76a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.67 400.3a18.14 18.14 0 01-4.29.26 18.14 18.14 0 01-4.29-.26 17.53 17.53 0 014.29-.26 17.53 17.53 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.67 425.14a18.14 18.14 0 01-4.29.26 18.14 18.14 0 01-4.29-.26 17.53 17.53 0 014.29-.26 17.53 17.53 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M243.26 425.38a35.44 35.44 0 01-8.57 0 35.44 35.44 0 018.57 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.41 425.12a17.53 17.53 0 01-4.29.26 17.48 17.48 0 01-4.28-.26 18.09 18.09 0 014.28-.26 18.14 18.14 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M188.23 450.25a18.14 18.14 0 01-4.29.26 18.14 18.14 0 01-4.29-.26 18.14 18.14 0 014.29-.26 18.14 18.14 0 014.29.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.72 450a17.48 17.48 0 01-4.28.26 17.53 17.53 0 01-4.29-.26 18.14 18.14 0 014.29-.26 18.09 18.09 0 014.28.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M242.8 450.25a35.52 35.52 0 01-8.58 0 35.52 35.52 0 018.58 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M188 400.53a17.53 17.53 0 01-4.29.26 17.53 17.53 0 01-4.29-.26 18.14 18.14 0 014.29-.26 18.14 18.14 0 014.29.26z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#455a64",
    transform: "matrix(1.2633 0 0 1.35546 -64.904 -154.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.34 466.55a38.31 38.31 0 00-2.06-7 7.8 7.8 0 00-6.56-4.2h-.71a7.78 7.78 0 00-6.56 4.2 37.54 37.54 0 00-2.06 7 32 32 0 00-1.47 9 10.13 10.13 0 003.3 7.65c1.82 1.57 4.46 1.94 7.15 1.89 2.9-.06 5.32-.32 7.15-1.89a10.21 10.21 0 003.3-7.65 32.69 32.69 0 00-1.48-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27 466.55a37.54 37.54 0 00-2.06-7 7.78 7.78 0 00-6.56-4.2h-.72a7.8 7.8 0 00-6.56 4.2 38.31 38.31 0 00-2.06 7 32.69 32.69 0 00-1.47 9 10.21 10.21 0 003.3 7.65c1.83 1.57 4.47 1.94 7.15 1.89 2.9-.06 5.32-.32 7.15-1.89a10.17 10.17 0 003.3-7.65 32 32 0 00-1.47-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.91 450.94c-2.54.26-6.36 19.19-7.92 27.51a4.73 4.73 0 003.33 5.38 18.24 18.24 0 0010.59.26 4.68 4.68 0 003.25-5.54c-1.88-8.16-6.72-27.87-9.25-27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.72 466.44c-1.37.14-3.44 10.39-4.28 14.89a2.56 2.56 0 001.8 2.91 9.92 9.92 0 005.73.14 2.53 2.53 0 001.76-3c-1.02-4.38-3.64-15.08-5.01-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.82 450.24c-2.53.25-6.35 19.19-7.91 27.51a4.72 4.72 0 003.33 5.38 18.2 18.2 0 0010.58.26 4.69 4.69 0 003.26-5.54c-1.89-8.16-6.73-27.85-9.26-27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 465.62c-1.37.14-3.44 10.39-4.28 14.89a2.56 2.56 0 001.8 2.91 9.83 9.83 0 005.73.14 2.53 2.53 0 001.76-3c-1.01-4.41-3.67-15.08-5.01-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.15 453.79c-2.53.24-6.35 17.91-7.91 25.66a4.4 4.4 0 003.33 5 19.46 19.46 0 0010.58.25 4.36 4.36 0 003.26-5.17c-1.89-7.59-6.72-25.98-9.26-25.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.26 465.81c-1.37.13-3.43 10.38-4.28 14.88a2.55 2.55 0 001.81 2.91 9.82 9.82 0 005.72.15 2.54 2.54 0 001.76-3c-1.02-4.42-3.63-15.08-5.01-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.23 450.26c-2.53.25-6.36 19.19-7.92 27.51a4.73 4.73 0 003.34 5.38 18.2 18.2 0 0010.58.26 4.69 4.69 0 003.26-5.54c-1.89-8.16-6.73-27.87-9.26-27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.76 465.75c-1.37.14-3.44 10.39-4.28 14.89a2.55 2.55 0 001.8 2.91 9.92 9.92 0 005.73.14 2.54 2.54 0 001.76-3c-1.02-4.41-3.64-15.08-5.01-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87 468.91c-1.16.12-2.91 8.78-3.62 12.59a2.15 2.15 0 001.52 2.46 8.33 8.33 0 004.84.12 2.15 2.15 0 001.49-2.54c-.86-3.73-3.1-12.75-4.23-12.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27 450.94c-2.53.26-6.36 19.19-7.92 27.51a4.73 4.73 0 003.34 5.38 18.2 18.2 0 0010.58.26 4.69 4.69 0 003.26-5.54c-1.89-8.16-6.73-27.87-9.26-27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.08 466.44c-1.37.14-3.43 10.39-4.28 14.89a2.56 2.56 0 001.8 2.91 9.92 9.92 0 005.73.14 2.53 2.53 0 001.76-3c-1.02-4.38-3.63-15.08-5.01-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23 468.91c-1.16.12-2.91 8.78-3.62 12.59a2.15 2.15 0 001.52 2.5 8.37 8.37 0 004.85.12 2.16 2.16 0 001.49-2.54c-.87-3.77-3.08-12.79-4.24-12.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88 466.6c-1.35.14-3.38 10.21-4.21 14.63a2.53 2.53 0 001.77 2.86 9.65 9.65 0 005.63.13 2.48 2.48 0 001.73-2.94c-1-4.34-3.57-14.82-4.92-14.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49 466.42c-1.38.14-3.45 10.41-4.3 14.92a2.57 2.57 0 001.81 2.92 9.87 9.87 0 005.74.14 2.55 2.55 0 001.77-3c-1.03-4.4-3.65-15.12-5.02-14.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionStatementPana);
export default __webpack_public_path__ + "static/media/vision-statement-pana.1fcb9cdadfee4f21f8fb6185b83d2ea8.svg";
export { ForwardRef as ReactComponent };